import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function ConsentCheckbox({ checked, onChange }) {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/consent/text").then(({ data }) => setInfo(data)).catch(() => {}); }, []);
  return (
    <label className="flex items-start gap-3 border border-[#E5E7EB] p-3 cursor-pointer hover:border-[#25AAAA]" data-testid="register-consent-label">
      <input type="checkbox" required checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="mt-1 h-4 w-4 accent-[#25AAAA]" data-testid="register-consent-checkbox" />
      <span className="text-xs text-[#0A0A0A] leading-relaxed">
        {info?.text || "I agree that iTeams may contact me by email about the programme for its duration."}{" "}
        <Link to="/privacy" target="_blank" className="text-[#25AAAA] font-medium hover:underline" data-testid="register-privacy-link">Read the privacy notice</Link>
      </span>
    </label>
  );
}
